import axios from "axios";
import { BASE_URL, SEARCH_USERS, JOIN_CLASS , GET_CLASS_RECORDINGS } from "@/common/apiEndpoints";
import { getAxiosOptions } from "@/common/utility";
import store from "@/store";
import { GET_TOKEN } from "@/store/getters";

// Module-level cached token variable

/**
 * Get the token from Vuex store and cache it
 * @returns {String} authentication token
 */
function getToken() {
  return store.getters[`schoolModule/${GET_TOKEN}`];
}

export function fetchUsers(payload) {
  const token = getToken();
  let url = SEARCH_USERS;
  return axios.post(url, payload, getAxiosOptions(BASE_URL, token));
}

export function joinClassThroughLink(payload) {
  const token = getToken();
  let url = JOIN_CLASS;
  return axios.post(url, payload, getAxiosOptions(BASE_URL, token));
}

export function getClassRecording(payload) {
  const token = getToken();
  let url = GET_CLASS_RECORDINGS;
  return axios.post(url, payload, getAxiosOptions(BASE_URL, token));
}

